import React from 'react';
import PropTypes from 'prop-types';

// Shared cross-step navigation buttons. Rendered inside each step's footer
// (modal__btns) div so they share a single parent with that step's action
// button(s). The visible buttons are chosen by currentStep.
const FormNavButtons = ({
  currentStep,
  goBackStep,
  cancelPersonalization,
}) => (
  <div className="modal__section modal__textBtns">

    {currentStep > 1 && currentStep <= 4 && (
      <button
        type="button"
        className="modal__textBtn modal__textBtn--minor"
        onClick={() => goBackStep()}
      >
        Go back a step
      </button>
    )}

    { currentStep > 1 && currentStep <= 4 && (
      <span className="modal__btnSeparator">or</span>
    )}

    {currentStep <= 4 && (
      <button
        type="button"
        className="modal__textBtn modal__textBtn--minor"
        onClick={() => cancelPersonalization()}
      >
        Cancel personalization
      </button>
    )}

  </div>
);

FormNavButtons.propTypes = {
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  goBackStep: PropTypes.func.isRequired,
  cancelPersonalization: PropTypes.func.isRequired,
};

export default FormNavButtons;
